import { getRuntimeConfig } from "@/lib/runtimeConfig";

type CognitoConfig = {
  clientId: string;
  cognitoDomain: string;
  logoutUri: string;
  redirectUri: string;
  authority: string;
  scope: string;
  region: string;
};

// Memoized to a stable reference per process. The earlier getter returned a
// fresh object on every `config.cognito` access, which silently broke any
// React dep array / useMemo that compared by reference and could fire a
// maximum-update-depth loop (React error #185).
//
// Values don't change during the life of a Lambda container (env vars are
// fixed per invocation) nor during a browser session (window.__VELYS_CONFIG__
// is injected once by layout.tsx), so caching is safe. A cold start after
// redeploy produces a fresh module instance with a fresh cache.
let _cognito: CognitoConfig | undefined;
function cognitoConfig(): CognitoConfig {
  if (_cognito) return _cognito;
  const rc = getRuntimeConfig();
  _cognito = {
    clientId: rc.clientId,
    cognitoDomain: rc.cognitoDomain,
    logoutUri: rc.logoutUri,
    redirectUri: rc.redirectUri,
    authority: rc.authority,
    scope: rc.scope,
    region: rc.region,
  };
  return _cognito;
}

const config = {
  apiBaseUrl: "/api",
  v1_apiBaseUrl: "/v1",
  get cognito() {
    return cognitoConfig();
  },
};

export default config;
